<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs3-02",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 43,
      nextPage: '/questionnaire/section3/3',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        mainTitle: 'Do you have any other diet preferences?',
        btn: [
          [
            {
              text: 'Ketogenic diet',
              operation: 'flag1-4_Prepare_add reminder 2 & flag1-4_Pregnancy_add reminder 2 & flag1-4_None_add reminder 6'
            }
          ],[
            {
              text: 'Paleo',
              operation: 'flag1-4_None_add reminder 7'
            }
          ],[
            {
              text: 'None',
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
